import React from 'react'
import Section from '../../../components/section'
import Flex from '../../../components/flex'
import Text from '../../../components/text'
import Button from '../../../components/button'
import usePayments from '../hooks/payments.hook';
import { useNavigate } from "react-router-dom"
import PaymentCard from '../../../components/paymentCard'
import Modal from '../../../components/modal'

const PaymentsView = () => {
    const navigate = useNavigate();
    const userId = sessionStorage.getItem('userId')
    const iFrameUrl=process.env.REACT_APP_CREDITCARD_IFRAME_URL
    console.log("iframeurl="+iFrameUrl)

    const {
        isModal,
        onOpenModal,
        onCloseModal,
        cardsList,
        deleteCard,
        isConfirmDeleteModal,
        onClosConfirmDeleteModal,
        onOpenConfirmDeleteModal,
        paymentIDToDelete
    } = usePayments();
    return (
        <Section>
            <Flex justifyContent="between" alignItemsCenter className="mb-3">
                <Text type="H1" text="Payment Method" />
                <Button 
                    type="button" 
                    text="+ Add New Card"
                    onClick={onOpenModal}
                    disabled={cardsList?.length > 0}
                />
            </Flex>
            <div className="row">
                
                {cardsList && cardsList?.map((item, index)=>{
                        return (
                            <div className="col-12 col-md-4">
                        <PaymentCard
                            cardId={item.id}
                        cardNumber={item.last_four}
                        nameonCard={item.card_holder}
                        bankName={item.bankName}
                        nickName={item.card_nick_name}
                        cardType={item.card_type}
                        zipCode={item.zip_code}
                            onDelete={()=>onOpenConfirmDeleteModal(item?.id)}
                        />
                            </div>
                        )
                    })}
             {cardsList?.length > 0 &&
                
                <div className="col-12 col-md-4">
                    <Text
                    type="PARAGRAPH"
                    className="mb-0" 
                    text="To update your payment information, please delete the current credit card. Once deleted, please ADD NEW CARD."
                    />
                </div>
            }
            </div>
            {isModal &&
                <Modal
                    onClose={onCloseModal}
                    onOuterClose={onCloseModal}
                    modalContent={
                        <div className="iframe-wrapper">
                             <iframe src={`${iFrameUrl}${userId}`}></iframe>
                           
                        </div>
                    }
                />
            }
            {isConfirmDeleteModal &&
                <Modal
                    modalSmall
                    light
                    canClose={false}
                    onClose={onClosConfirmDeleteModal}
                    modalContent={
                        <Flex className="gap-3" flexColumn justifyContent="center" alignItemsCenter>
                            <Text className="text-center" type={"H4"} text={"Are you sure"} />
                            <Flex justifyContent="center" alignItemsCenter className={"gap-3"}>
                                <Button type="button" text={"yes"} onClick={()=>{deleteCard(paymentIDToDelete)}} />
                                <Button type="button" link text={"No"} onClick={onClosConfirmDeleteModal} />

                            </Flex>
                        </Flex>
                    }
                />
            }
        </Section>
    )
}

export default PaymentsView